module.exports = __webpack_public_path__ + "9250eea244eeef7e141cd9363cf8e4c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/news/temp.jpg
// module id = 268
// module chunks = 0